import { Dropdown, Option } from '@joor/design-system'

import IDs from '../../reassignConnectionsModal.ids'
import messages from '../../reassignConnectionsModal.messages'
import { Actions } from '../../reassignConnectionsModal.types'
import useStore from '../../store/useReassignConnectionsStore'

interface SourceUserDropdownProps {
  options: Option[]
  isLoading: boolean
}

const TargetUserDropdown = ({
  options,
  isLoading,
}: SourceUserDropdownProps): JSX.Element | null => {
  const action = useStore((state) => state.action)
  const sourceUser = useStore((state) => state.sourceUser)
  const targetUser = useStore((state) => state.targetUser)
  const setTargetUser = useStore((state) => state.setTargetUser)
  const salesReps = useStore((state) => state.salesReps)

  const dropdownOptions = [...options]
  const sourceUserOptionIndex = dropdownOptions.findIndex(
    (option) => option.value === sourceUser?.id,
  )

  if (sourceUserOptionIndex > -1) {
    dropdownOptions.splice(sourceUserOptionIndex, 1)
  }

  const selectedTargetUserOption = options.find(
    (option) => option.value === targetUser?.id,
  )

  if (!sourceUser || action !== Actions.REASSIGN) {
    return null
  }

  return (
    <Dropdown
      id={IDs.TargetUserDropdown}
      testId={IDs.TargetUserDropdown}
      label={messages.newSalesRep}
      options={dropdownOptions}
      isLoading={isLoading}
      isDisabled={isLoading}
      menuPlacement="top"
      value={selectedTargetUserOption}
      onSelect={({ selected }: { selected: Option }) => {
        const selectedUser = salesReps.find(
          (user) => user.id === selected.value,
        )
        if (!selectedUser) return
        setTargetUser({ targetUser: selectedUser })
      }}
    />
  )
}

export default TargetUserDropdown
